export const ZOOM_LOCAL = 14;
